import { useEffect } from "react";
import { useLocation } from "react-router";
import { Box, Container, AppBar, Toolbar } from "@mui/material";
import { scroller } from "react-scroll";
import { useGetProductsQuery } from "@/redux-store/api/marketingApi";
import useResponsive from "@/hooks/useResponsive";
import "./styles.css";

import MobileMenu from "./MobileMenu";
import NavBar from "./NavBar";
import TopBar from "./TopBar";

const Header = () => {
  const isDesktop = useResponsive("up", "lg");
  const location = useLocation();


    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data: _products } = useGetProductsQuery({}); // Get products for solutions menu

  const scrollToTop = () => {
    scroller.scrollTo("topOfPage", {
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  // Scroll to top on page change
  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  return (
    <Box component="header" id="topOfPage">
        <TopBar />
      <Container>
        <AppBar
          position="relative"
          sx={{
            background: "white",
            border: "none",
            boxShadow: "none",
            zIndex: 100,
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Mobile nav menu  */}
            {!isDesktop && <MobileMenu />}

                  {/* Desktop nav menu */}
                  {isDesktop && <NavBar/>}

              </Toolbar>
          </AppBar>
      </Container>
    </Box>
  );
};

export default Header;
